<template>

	<!-- <div class="block">
		<h2 class="heading2">スタジオからのお知らせ</h2>
		<p style="color:red">スタジオからのお知らせ予定地</p>
	</div> -->
	<my-bloginfo v-if="!isPageFlg" name="" title="スタジオからのお知らせ"></my-bloginfo>

	<template v-if="isPageFlg && !xsflg">
	<div class="block">
		<my-advancedsearch></my-advancedsearch>
	</div>
	</template>

	<div class="block">
		<my-subcategories></my-subcategories>
	</div>

	<div class="block">
		<my-posts categoryname="selection" :perpage="8" title="レンタル撮影スタジオ厳選シリーズ（エリア×特徴）" archivelink="//studio.powerpage.jp/contents/category/selection" :showthumb="false"></my-posts>
	</div>

	<!-- <div class="block">
		<ul class="linkList2">
			<li><a href="//studio.powerpage.jp/contents/category/newstopics"><i class="glyphicon glyphicon-arrow-right"></i> studio DATA BASE からのお知らせ</a></li>
		</ul>
	</div> -->

	<div class="block">
		<my-favorite></my-favorite>
	</div>

	<my-history></my-history>

	<div class="block">
		<my-posts categoryname="studiorepo" :perpage="4" title="スタジオルポ" archivelink="//studio.powerpage.jp/contents/category/studiorepo"></my-posts>
	</div>

	<div class="block">
		<my-posts categoryname="use" :perpage="4" title="レンタルスタジオ活用術" archivelink="//studio.powerpage.jp/contents/category/use"></my-posts>
	</div>

	<div>
		<h2 class="heading2">FACE BOOK</h2>
		<div class="fb-page" data-href="https://www.facebook.com/studio.powerpage.jp/" data-tabs="timeline" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/studio.powerpage.jp/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/studio.powerpage.jp/">POWER PAGE</a></blockquote></div>
	</div>

	<!-- <div class="block">
		<my-posts categoryname="new-face" :perpage="4" title="New Face" archivelink="//studio.powerpage.jp/contents/category/new-face"></my-posts>
	</div> -->

	<!-- <div class="block">
		<div class="bnr">
			<a href="http://iziz.co.jp/rental/" target="_blank"><img src="/static/images/bnr/2016newitem.jpg" class="img-responsive" alt="New ITEMS 2016 from  LA and UK, EASE"></a>
		</div>
	</div> -->

	<!-- <div class="block">
		<div class="bnr">
			<a href="http://powerpage.jp/" target="_blank"><img src="/static/images/bnr/powerpage.jpg" class="img-responsive" alt="広告クリエイターのためのイエローページ POWER PAGE by COMMERCIAL PHOTO"></a>
		</div>
		<div class="bnr">
			<a href="http://switch.genkosha.com/" target="_blank"><img src="/static/images/bnr/joboffer.jpg" class="img-responsive" alt="写真・デザイン・映像・広告業界の求人サイト SWITCH"></a>
		</div>
		<div class="bnr">
			<a href="https://www.facebook.com/powerpage.jp" target="_blank"><img src="/static/images/bnr/facebook.jpg" class="img-responsive" alt="POWER PAGE by COMMERCIAL PHOTO on facebook"></a>
		</div>
	</div> -->
</div>
</template>

<script>
module.exports = {
	props: {
		xsflg: ''
	},
	created: function(){
	},
	ready: function(){
		// this.$broadcast('foo');
		// console.log(this.xsflg);
	},
	computed: {
		isPageFlg: function(){
			return this.$route.isPage;
		}
	},
	components: {
		'my-posts': require('./posts.vue'),
		'my-subcategories': require('./subcategories.vue'),
		'my-favorite': require('./widget_favorites.vue'),
		'my-advancedsearch': require('./widget_advanced_search.vue'),
		'my-history': require('./widget_history.vue'),
		'my-bloginfo': require('./widget_bloginfo.vue')
	}
};
</script>

<style scoped lang="scss">
.bnr{
	margin-right: auto;
	margin-left: auto;
	max-width: 320px;
}
</style>



// WEBPACK FOOTER //
// sidebar.vue?52853e0c